import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BettingRoutingModule } from './betting-routing.module';
import { BettingComponent } from './betting.component';
import { HeaderBarModule } from '../header-bar/header-bar.module';
import { NumbersGridModule } from '../numbers-grid/numbers-grid.module';
import { QuickTippComponent } from './quick-tipp/quick-tipp.component';
import { SuccessComponent } from './success/success.component';
import { PunterBarModule } from '../punter-bar/punter-bar.module';
import { FormsModule } from '@angular/forms';
import { ErrorMessageComponent } from './error/error-message.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    BettingRoutingModule,
    HeaderBarModule,
    NumbersGridModule,
    PunterBarModule,
    FormsModule,
    SharedModule
  ],
  declarations: [BettingComponent, QuickTippComponent, SuccessComponent, ErrorMessageComponent]
})
export class BettingModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/betting/betting.module.ts